import { useCallback, useEffect, useState } from 'react';
import { api } from '../api/client';
import type { OpenPuzzlesResponse } from '../api/types';

interface OpenPuzzlesState {
  dates: string[];
  error: string | null;
}

interface UseOpenPuzzlesResult extends OpenPuzzlesState {
  refresh(): Promise<void>;
}

/**
 * Spieltage, die der eingeloggte Spieler noch nachholen kann (kein
 * eigener Eintrag, Hinweise + Lösung vorhanden). Tage nach `today` werden verworfen — die Tag-Navigation kann
 * dort ohnehin nicht hin (der Server kennt nur UTC, nicht den lokalen
 * Tag des Handys).
 */
export function useOpenPuzzles(today: string): UseOpenPuzzlesResult {
  const [state, setState] = useState<OpenPuzzlesState>({ dates: [], error: null });

  const refresh = useCallback(async (): Promise<void> => {
    try {
      const { data } = await api.get<OpenPuzzlesResponse>('/puzzle/open');
      setState({ dates: data.dates.filter((d) => d <= today), error: null });
    } catch {
      setState({ dates: [], error: 'Offene Rätsel konnten nicht geladen werden' });
    }
  }, [today]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { ...state, refresh };
}
